import { WebSocketAbstract, WebSocketEnvelop, EnvelopBody, EnvelopMessage } from './websocket-abstract';
import { WebSocketJboss } from './websocket-jboss';
import { WebSocketVertx } from './websocket-vertx';
import { Subject } from 'rxjs';

declare let iNet: any;
declare let $: any;

export class WebSocketClient {
    static instance: WebSocketClient = null;
    socket: WebSocketAbstract;
    // message from socket server
    onMessage: Subject<EnvelopBody> = new Subject();
    // socket state change
    onStateChange: Subject<any> = new Subject();
    // envelop send will be timeout after 30s
    sendTimeout: number = 30000;
    private _username: string;
    private _autoconnect: boolean;
    private _autoconnectAfter: number = 5000; // 5s
    private _autoconnectRepeat: number = 4; // 5 times
    private _autoconnectRetryAfter: number = 30000; // 30s
    private _autoconectCount: number;
    private _autoconectTimer: any;
    private _envelopQueue = [];

    get readyState(): number {
        return this.socket ? this.socket.readyState : null;
    }

    get connecting(): boolean {
        return this.readyState === WebSocket.CONNECTING || this.readyState === null;
    }

    get connected(): boolean {
        return this.readyState === WebSocket.OPEN;
    }

    get closing(): boolean {
        return this.readyState === WebSocket.CLOSING;
    }

    get closed(): boolean {
        return this.readyState === WebSocket.CLOSED;
    }

    get autoconnect(): boolean {
        return this._autoconnect;
    }

    constructor() {
        if (!WebSocketClient.instance) {
            this._getAccountInfo(() => this._register());
        }
        return WebSocketClient.instance = WebSocketClient.instance || this;


    }

    // close websocket client
    close() {
        this.socket.close();
    }

    send(address: string, message: string, application: string = ''): Promise<boolean> {
        return this.sendEnvelop(this.buildEnvelop(address, message, application));
    }

    sendEnvelop(envelop: WebSocketEnvelop): Promise<boolean> {
        if (this.connected) {
            return this.socket.send(envelop);
        } else {
            return new Promise((resolve) => {
                // Add to queue and waiting socket connected to send
                let data: any = {
                    e: envelop,
                    f: resolve
                };
                data.timer = setTimeout(() => this._completeEnvelopQueue(data, false), this.sendTimeout);
                this._envelopQueue.push(data);
            });
        }
    }

    buildEnvelop(address: string, message: string, application: string = '', join?: string): WebSocketEnvelop {
        let envelop = new WebSocketEnvelop();
        envelop.address = address;
        envelop.body = new EnvelopBody();
        envelop.body.application = application;
        envelop.body.sender = this._username;
        envelop.body.alias = [address];
        envelop.body.message = new EnvelopMessage(this._username, message, join || '');
        return envelop;
    }

    private _sendEnvelopQueue() {
        this._envelopQueue.forEach((data) => {
            this.sendEnvelop(data.e).then((status) => this._completeEnvelopQueue(data, status));
        });
    }

    private _completeEnvelopQueue(data: any, status: boolean) {
        const index = this._envelopQueue.indexOf(data);
        if (index >= 0) {
            this._envelopQueue.splice(index, 1);
        }
        data.f(status);
    }

    private _register(callback?: Function) {
        $.ajax({
            url: iNet.getPUrl('account/register'),
            success: (data: string | string[]) => {
                if (typeof data === 'string') {
                    this.socket = new WebSocketJboss(data, this._username);
                } else {
                    this.socket = new WebSocketVertx(data, this._username);
                }
                this.socket.onStateChange.subscribe(() => this._stateChange());
                this.socket.onMessage.subscribe((body: EnvelopBody) => {
                    this.onMessage.next(body);
                });
                callback && callback();
            },
            error: () => {
                callback && callback();
                throw new Error("Account register error");
            }
        });
    }

    private _getAccountInfo(callback: Function) {
        if (this._username) {
            return callback(this._username);
        }
        $.ajax({
            url: iNet.getPUrl('system/userprofile/view'),
            success: (data: any) => {
                this._username = data && data.user && (data.user.usercode || data.user.username) || '';
                callback(this._username);
            },
            error: () => callback(null)
        });
    }

    private _stateChange() {
        if (this.closed && !this.autoconnect) {
            this._runAutoConnect();
        }
        if (this._autoconnect) {
            return;
        }
        if (this.connected) {
            this._sendEnvelopQueue();
        }
        this._cancelAutoConnect();
        this.onStateChange.next();
    }

    private _runAutoConnect() {
        this._autoconnect = true;
        this._autoconectTimer = setTimeout(() => {
            if (this.connected) {
                this._cancelAutoConnect();
                return;
            }
            if (this._autoconectCount >= this._autoconnectRepeat) {
                this._cancelAutoConnect();
                // Sleep and retry connect after 30s
                setTimeout(() => this._runAutoConnect(), this._autoconnectRetryAfter);
                return;
            }


            this._register(() => {
                this._autoconectCount++;
                if (!this.connected) {
                    this._runAutoConnect();
                }
            });
        }, this._autoconnectAfter);
    }

    private _cancelAutoConnect() {
        this._autoconnect = false;
        this._autoconectCount = 0;
        clearTimeout(this._autoconectTimer);
    }
}